import React, { useState, useRef, useEffect } from "react";
import {useHistory} from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useFormik } from 'formik';
import ProgressBar from "../../shared/ProgressBar/Progress";
import { url } from "../../reducers/url";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PersonalDB from "../../services/personaldb";
 
let isCancelled = false;

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
        width: '96%',
    },
    tableLayout: {
        width: '96%',
        boxSizing: 'border-box',
        margin: '0px',
        borderRight: '1px solid #dcd7c0',
        borderLeft: '1px solid #dcd7c0',
        borderBottom: '1px solid #dcd7c0',
    },
    textAreaCss: {
        marginLeft: '23px',
    },
    fontDetails: {
        fontFamily: 'verdana, helvetica',
        fontSize: '12px'
    },
}));
 
function PatentNumber() {
    const classes = useStyles();
    const history = useHistory();
    const { t } = useTranslation('common');
    const [searching,setSearching] = useState(false);
    const [vdbName, setVdbName] = useState('');
    const [vdbNameError, setVdbNameError] = useState(false);
    const [vdbNameErrorMessage, setVdbNameErrorMessage] = useState('');
    const [existingDatabases, setExistingDatabases] = useState([]);
    const [textareaError, setTextareaError] = useState('');
    const fileInputRef = useRef(null);
    const toggle = useSelector(state => state.setToggle.toggle);
    const formik = useFormik({
        initialValues: {
            textareaId: '',
            searchType: 'type1',
            patentDB: 'all',
            virtualDatabaseCheckbox: false,
        },
    });
 
    useEffect(() => {
        const unlisten = history.listen(() => {
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
        });

        return () => {
            unlisten();
        };
    }, [history]);
    
    // Fetch existing databases on component mount
    useEffect(() => {
        (async () => {
            await fetchExistingDatabases();
        })();
    }, []);
    
    // Fetch existing personal databases
    const fetchExistingDatabases = async () => {
        try {
            const userInfo = await PersonalDB.getUserInfo();
            if (userInfo && userInfo.response_content && userInfo.response_content.home_folder_id) {
                const homeId = userInfo.response_content.home_folder_id;
                const result = await PersonalDB.getPersonalData(homeId);
                if (result && result.response_content && result.response_content.results) {
                    const databases = result.response_content.results
                        .filter(item => item.type === 'DlPhysicalSeqdb' || item.type === 'DlVirtualSeqdb')
                        .map(item => {
                            // Remove only " - Nucleotide" or " - Protein" suffixes
                            let description = item.description.trim();
                            if (description.endsWith(' - Nucleotide')) {
                                description = description.replace(' - Nucleotide', '');
                            } else if (description.endsWith(' - Protein')) {
                                description = description.replace(' - Protein', '');
                            }
                            return description.toLowerCase();
                        });
                    setExistingDatabases(databases);
                }
            }
        } catch (error) {
            console.error('Error fetching existing databases:', error);
        }
    };
    
    // Check if database name already exists
    const isDatabaseNameDuplicate = (name) => {
        let trimmedName = name.trim();
        // Remove only " - Nucleotide" or " - Protein" suffixes from input as well
        if (trimmedName.endsWith(' - Nucleotide')) {
            trimmedName = trimmedName.replace(' - Nucleotide', '');
        } else if (trimmedName.endsWith(' - Protein')) {
            trimmedName = trimmedName.replace(' - Protein', '');
        }
        return existingDatabases.includes(trimmedName.toLowerCase());
    };
    
    // Generate VDB name with current timestamp
    const generateVdbName = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `vdb_${year}${month}${day}${hours}${minutes}${seconds}`;
    };
    
    // Handle virtual database checkbox change
    const handleVdbCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        formik.handleChange(e);
        if (isChecked) {
            const generatedName = generateVdbName();
            setVdbName(generatedName);
            // Check if the generated name is a duplicate
            if (isDatabaseNameDuplicate(generatedName)) {
                setVdbNameError(true);
                setVdbNameErrorMessage('A database with this name already exists');
            } else {
                setVdbNameError(false);
                setVdbNameErrorMessage('');
            }
        } else {
            setVdbName('');
            setVdbNameError(false);
            setVdbNameErrorMessage('');
        }
    };
    
    // Handle VDB name input change
    const handleVdbNameChange = (e) => {
        const value = e.target.value;
        setVdbName(value);
        
        // Check if empty
        if (value.trim() === '') {
            setVdbNameError(true);
            setVdbNameErrorMessage('Database name cannot be empty');
            return;
        }
        
        // Check if duplicate
        if (isDatabaseNameDuplicate(value)) {
            setVdbNameError(true);
            setVdbNameErrorMessage('A database with this name already exists');
            return;
        }
        
        // Valid name
        setVdbNameError(false);
        setVdbNameErrorMessage('');
    };
    
    function showfil() {
        console.log("showfil called");
        if (window.File && window.FileReader && window.FileList && window.Blob) {
            var preview = document.getElementById('textareaId');
            var file = document.querySelector('input[type=file]').files[0];
            var reader = new FileReader();

            var textFile = /text.*/;
            if (file.type.match(textFile) || file.type === "application/vnd.ms-excel") {
                reader.onload = function (event) {
                    var content = event.target.result;
                    preview.value = content;
                    formik.setFieldValue("textareaId", content);
                };
            } else {
                preview.innerHTML =
                    "<span class='error'>It doesn't seem to be a valid patent number!</span>";
            }
            reader.readAsText(file);
        }
    }  
 
    function openWindowWithPost(url, data) {
        var form = document.createElement("form");
        form.method = "POST";
        form.action = url;
        form.style.display = "none";
    
        for (var key in data) {
            var input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = data[key];
            form.appendChild(input);
        }
    
        document.body.appendChild(form);
        form.submit();
    }
 
    const handleSearch = async () => {
        const tokens = formik.values.textareaId.split(/[\s,;]+/).filter(t => t.trim() !== "");
        const patentPattern = /^[A-Z]{2,4}\d+[A-Z0-9]*$/i;
        const invalidTokens = tokens.filter(t => !patentPattern.test(t.trim()));
        if (invalidTokens.length > 0) {
            setTextareaError("Invalid patent number(s): " + invalidTokens.join(", "));
            return;
        }
        setTextareaError("");
        setSearching(true);

        if (!searching && formik.values.textareaId) {
            await new Promise((resolve) => setTimeout(resolve, 2000));
            const state = { 
                textareaId: formik.values.textareaId, // Textarea data
                searchType: formik.values.searchType, // Radio button for search type
                patentDB: formik.values.patentDB, // Radio button for patent database
                includeVirtualDB: document.getElementById("virtualDatabaseCheckbox").checked, // Checkbox data
            };
            
            // Only add vdbName if virtualDatabaseCheckbox is checked
            if (formik.values.virtualDatabaseCheckbox) {
                state.vdbName = vdbName;
            }
            if (!isCancelled) {
                history.push({
                    pathname: "/patentnumbersearch/fieldsearch",
                    state: state
                });
            }
            isCancelled = false;
        }
        else if (!formik.values.textareaId) {
            await new Promise((resolve) => setTimeout(resolve, 2000));
            if (!isCancelled) {
                const postData = {
                    q: formik.values.textareaId,
                    field: 'PN',
                    include_pm: formik.values.searchType === "type1" ? false : true,
                    send_email: document.getElementById("virtualDatabaseCheckbox").checked,
                    include_dbs: formik.values.patentDB
                };
                
                // Only add vdb_name if virtualDatabaseCheckbox is checked
                if (formik.values.virtualDatabaseCheckbox) {
                    postData.vdb_name = vdbName;
                }
                
                const apiUrl = process.env.REACT_APP_API_URL + 'do=gqfetch.field_search';
                
                openWindowWithPost(apiUrl, postData);
            }
            isCancelled = false;
        }
    };

    async function onCancelSearch() {
        setSearching(false);
        isCancelled = true;
        history.push('/patentnumbersearch');
    }

    const isSearchEmpty = !formik.values.textareaId || formik.values.textareaId.trim() === '';

    return (
        <div className="grow">
            <div className={classes.tableLayout}>
                <form>
                    <div>
                        <div style={{ padding: '5px' }}>
                            <div className={classes.fontDetails} >
                                <div align='right' > 
                                Browse: <a className={classes.fontDetails} href={process.env.REACT_APP_API_URL + url.allPatentsLink} target="_blank" rel="noreferrer" >{t('allPatents')}</a>
                                    <span className={classes.fontDetails} style={{ color: 'grey' }}> | </span>
                                    <a className={classes.fontDetails} href={process.env.REACT_APP_API_URL + url.allNucleotidePatentsLink} target="_blank" rel="noreferrer" >{t('allNucleotidePatents')}</a>
                                    <span className={classes.fontDetails} style={{ color: 'grey' }}> | </span>
                                    <a className={classes.fontDetails} href={process.env.REACT_APP_API_URL + url.allProteinPatentsLink} target="_blank" rel="noreferrer" >{t('allProteinPatents')}</a>
                                </div>
                            </div>
                            <div>
                                <input
                                    id="searchType1"
                                    type="radio"
                                    name="searchType"
                                    style={{ marginLeft: '25px' }}
                                    value="type1"
                                    checked={formik.values.searchType === "type1"}
                                    onChange={formik.handleChange}
                                />
                                <label className="pnTextData" style={{ marginLeft: '6px' }} htmlFor="searchType1">Search Patents Only</label>
                                <input
                                    id="searchType2"
                                    type="radio"
                                    name="searchType"
                                    style={{ marginLeft: '13px' }}
                                    value="type2"
                                    checked={formik.values.searchType === "type2"}
                                    onChange={formik.handleChange}
                                />
                                <label className="pnTextData" style={{ marginLeft: '6px' }} htmlFor="searchType2">Search Patents & Patent Families</label>
                            </div>
                            <div>
                                <label style={{ marginLeft: '25px' }}><b>Database :</b></label>
                                <input
                                    id="nuc"
                                    type="radio"
                                    name="patentDB"
                                    style={{ marginLeft: '20px' }}
                                    value="nuc"
                                    checked={formik.values.patentDB === 'nuc'}
                                    onChange={formik.handleChange}
                                />
                                <label className="pnTextData" style={{ marginLeft: '6px' }} htmlFor="nuc">Nucleotide Data</label>
                                <input
                                    id="pro"
                                    type="radio"
                                    name="patentDB"
                                    style={{ marginLeft: '20px' }}
                                    value="pro"
                                    checked={formik.values.patentDB === 'pro'}
                                    onChange={formik.handleChange}
                                />
                                <label className="pnTextData" style={{ marginLeft: '6px' }} htmlFor="pro">Protein Data</label>
                                <input
                                    id="all"
                                    type="radio"
                                    name="patentDB"
                                    style={{ marginLeft: '20px' }}
                                    value="all"
                                    checked={formik.values.patentDB === 'all'}
                                    onChange={formik.handleChange}
                                />
                                <label className="pnTextData" style={{ marginLeft: '6px' }} htmlFor="all">Both</label>
                            </div>
                            <div style={{ marginLeft: '25px' }}>
                                <input
                                    type="checkbox"
                                    id="virtualDatabaseCheckbox"
                                    name="virtualDatabaseCheckbox"
                                    checked={formik.values.virtualDatabaseCheckbox}
                                    onChange={handleVdbCheckboxChange}
                                />
                                <label style={{ marginLeft: '6px' }} htmlFor="virtualDatabaseCheckbox">
                                    Create Virtual Database(s){!formik.values.virtualDatabaseCheckbox && ' - email will be sent when complete'}
                                </label>
                                {formik.values.virtualDatabaseCheckbox && (
                                    <>
                                        <label style={{ marginLeft: '15px', marginRight: '5px' }} htmlFor="vdbNameInput">
                                            <b>Name:</b>
                                        </label>
                                        <input 
                                            type="text" 
                                            autoComplete="off" 
                                            spellCheck="false"
                                            className={'filter-widget-input-textarea ' + (vdbNameError ? 'input-with-error' : '')}
                                            style={{ width: '200px', display: 'inline-block' ,color: toggle? '#777':'white' }} 
                                            placeholder="Enter VDB name"
                                            value={vdbName}
                                            onChange={handleVdbNameChange} 
                                        />
                                        {vdbNameError && vdbNameErrorMessage && (
                                            <span style={{ color: 'red', marginLeft: '10px', fontSize: '12px' }}>
                                                {vdbNameErrorMessage}
                                            </span>
                                        )}
                                        <div>
                                            <label style={{ marginLeft: '6px' }}>
                                                - email will be sent when complete
                                            </label>
                                        </div>
                                    </>
                                )}
                                <div>
                                    
                                </div>
                            </div>
                            <div className={classes.textAreaCss}>
                                {formik.values.virtualDatabaseCheckbox && (
                                    <div style={{ marginTop: '10px', marginLeft: '6px' }}>
                                        
                                    </div>
                                )}
                            </div>
                            <div className={classes.textAreaCss}>
                                {toggle ?
                                    <textarea
                                        id="textareaId"
                                        name="textareaId"
                                        style={{ border: '1px solid #dcd7c0', width: '98%', height: '150px', outline: 'none', fontFamily: 'verdana, helvetica', fontSize: '14px' }}
                                        value={formik.values.textareaId}
                                        onChange={(e) => { setTextareaError(''); formik.handleChange(e); }}
                                    ></textarea>
                                    :
                                    <textarea
                                        id="textareaId"
                                        name="textareaId"
                                        style={{ border: '1px solid #dcd7c0', width: '98%', height: '150px', outline: 'none', fontFamily: 'verdana, helvetica', fontSize: '14px', backgroundColor: '#292929', color: 'white' }}
                                        value={formik.values.textareaId}
                                        onChange={(e) => { setTextareaError(''); formik.handleChange(e); }}
                                    ></textarea>
                                }
                                {textareaError && (
                                    <span style={{ color: 'red', fontSize: '12px', marginLeft: '4px' }}>
                                        {textareaError}
                                    </span>
                                )}
                            </div>
                            <p className="pnTextData" style={{margin:'12px'}}>For example: WO2010151773
                                US20080038787,
                                EP1721609,
                                WO200209645,
                                AU9052001, EP1073751, US707495
                            </p>

                            <p className="pnTextData" style = {{margin:'8px 0px 8px 22px !important'}}> <b id="show-text">Upload .csv or .txt file</b></p>
                            <input
                                ref={fileInputRef}
                                style={{ padding: '0px 0px 27px 24px' }}
                                type="file"
                                accept=".csv, .txt"
                                onChange={showfil}
                            />
                            {searching && (
                                <React.Fragment>
                                    <ProgressBar getStatus={"default"} datas={""} />
                                </React.Fragment>
                            )}

                            <table>
                                <tbody>
                                    <tr>
                                        <td style={{ width: '50%' }}>
                                            <ul className="pnTextData">
                                                <li>Selected patent databases will be searched</li>
                                                <li>Patent numbers can be separated by comma, semicolon, space or newline</li>
                                                {/*<li>Patent number and patent family fields will be searched</li>*/}
                                                <li>Patent numbers will automatically be reformatted to comply with GQ standards</li>
                                            </ul>
                                        </td>
                                        <td align="right" style={{ width: '50%' }}>
                                            <span>
                                                <span>
                                                    {searching && <button
                                                        className='DMTBtn'
                                                        style={{ padding: '5px 10px', fontSize: '18px' }}
                                                        onClick={onCancelSearch}
                                                    >
                                                        <b>Cancel</b>
                                                    </button>
                                                    }
                                                    <Button
                                                        variant="contained"
                                                        disableRipple={true}
                                                        className={"ftSearchButton " + (isSearchEmpty ? 'submitDisabled' : 'loginSubmitButton')}
                                                        onClick={handleSearch}
                                                        disabled={formik.values.virtualDatabaseCheckbox && vdbNameError}
                                                        style={isSearchEmpty
                                                            ? (toggle
                                                                ? { padding: '0px 37px', backgroundColor: 'rgba(0, 0, 0, 0.12)', color: 'rgba(0, 0, 0, 0.26)', boxShadow: 'none' }
                                                                : { padding: '0px 37px', background: '#736d6d', color: '#fff', boxShadow: 'none' })
                                                            : (toggle
                                                                ? { padding: '0px 37px' }
                                                                : { background: '#736d6d', padding: '0px 37px' })}
                                                    >
                                                        Search
                                                    </Button>
                                                </span>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </form>
            </div >
        </div >
    )
}
export default PatentNumber;
